import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { take } from 'rxjs';
import { UserResource } from 'src/app/core/models/user-resource.model';
import { CoreService } from 'src/app/core/services/core.service';
import { MessageService } from 'src/app/core/services/message.service';
import { AuthenticationService } from 'src/app/modules/authentication/services/authentication.service';
import { SharedModule } from '../../shared.module';

@UntilDestroy()
@Component({
  selector: 'app-user-selection-menu',
  templateUrl: './user-selection-menu.component.html',
  styleUrl: './user-selection-menu.component.less',
  standalone: true,
  imports: [SharedModule, NzMenuModule, NzDropDownModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSelectionMenuComponent implements OnChanges {
  @Input() visible = false;
  @Output() isLoading = new EventEmitter<boolean>();
  userResources: Array<UserResource> | undefined;

  constructor(
    private authenticationService: AuthenticationService,
    private coreService: CoreService,
    private readonly messageService: MessageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.visible && changes.visible.currentValue) {
      if (this.userResources === undefined) {
        this.isLoading.next(true);
      }
      this.fetchUserResources();
    }
  }

  fetchUserResources(): void {
    this.coreService
      .getUserResources$()
      .pipe(take(1), untilDestroyed(this))
      .subscribe((userResources) => {
        this.isLoading.next(false);
        this.userResources = userResources;
      });
  }

  switch(userResource: UserResource): void {
    this.authenticationService
      .refreshToken$(String(userResource.id))
      .pipe(take(1))
      .subscribe((result) => {
        this.messageService.showSuccess($localize`Gewisseld naar "${result.role}:roleName:".`);
        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
  }
}
